/**
 * TODO: Add Documentation
 */
import React from "react";
import {Card, CardContent, Grid, Typography} from "@material-ui/core";
import LoggedOn from "../../../../../component/Main/Base/LoggedOn/LoggedOn";
import CustomerTopMenu from "../../components/menu/CustomerTopMenu";
import securePage from "../../../../SecurePage/SecurePage";
import {roles} from "../../../../../../api/login/LoginClient";

// TODO: Remove; this class will be obsolete as soon as the PortalPrivateCustomer page is updated to the new setup

const Documents = () => (
    <LoggedOn pageHeader={<CustomerTopMenu/>}>
        <Grid item
              lg={12}
              md={12}
              sm={12}>
            <Card>
                <CardContent>
                    <Typography variant="subtitle1">
                        Documenten
                    </Typography>
                </CardContent>
            </Card>
        </Grid>

    </LoggedOn>
);

export default securePage([roles.admin])(Documents);

